<div
  *ngIf="$any(newsHtml)['changingThisBreaksApplicationSecurity']"
  class="news-text"
  [innerHTML]="newsHtml"
  data-test-id="news-html-text"
></div>
